export default function (value: any, currency: string = 'BRL', symbol: string = 'R$',
  digits: number = 2) {
  if (value === null || value === undefined) return '-';
  if (value === '-' || value === '') return ` ${symbol}-`;
  if (currency === '') {
    currency = 'BRL';
  }
  if (symbol === '') {
    symbol = 'R$';
  }
  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency,
    minimumFractionDigits: digits,
  });
  return formatter.format(value);
}
